html {
  overflow: hidden;
  font-size: 14px;
}
body {
  overscroll-behavior-y: contain;
  overflow-x: hidden;
  scroll-behavior: smooth;
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, "Noto Sans", sans-serif !important;
}

/* remove blue outline in webkit browers for input */
input:focus {
  outline: 0 !important;
}

a {
  text-decoration: underline;
}
